// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"80507d5d","511":"ec3a7d07","571":"0461c665","745":"2b54d873","787":"a83accd8","877":"953a452f","954":"ca505789"}[chunkId] + ".chunk.js";
};